import React, { createContext, useEffect } from 'react';
import { Connection, clusterApiUrl } from '@solana/web3.js';
import { useWallet } from '@solana/wallet-adapter-react';

export const SolanaContext = createContext();

export const SolanaProvider = ({ children }) => {
  const wallet = useWallet();
  const connection = new Connection(clusterApiUrl('devnet')); // Or mainnet-beta

  return (
    <SolanaContext.Provider value={{ wallet, connection }}>
      {children}
    </SolanaContext.Provider>
  );
};